import { QUERY_KEY_USER_PROFILE_DATA } from '@montugroup/circuit-shared/hooks/user/useGetUserProfile';
import type { IUserProfileResponse } from '@montugroup/circuit-shared/types/user';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export const usePatientClientCode = (
  options?: Omit<UseQueryOptions<IUserProfileResponse, Error, string>, 'queryKey' | 'select'>,
) =>
  useQuery<IUserProfileResponse, Error, string>({
    queryKey: [QUERY_KEY_USER_PROFILE_DATA],
    select: (data) => data.patient.client_code,
    refetchOnMount: false,
    ...options,
  });
